import {
  Box,
  makeStyles,
  TextField,
  Typography,
  withStyles,
  Button,
  Popover
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import PropTypes from 'prop-types';
import { useState, useCallback } from 'react';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import CreateUser from './CreateUser';
import { useTheme, useMediaQuery } from '@material-ui/core';
import CommonFilterBox from './FilterPopover';
import SearchInput from '../../../components/input/SearchInput';

const CssTextField = withStyles({
  root: {
    margin: 0
  }
})(TextField);
const Toolbar = ({ searchRef, listProvinces }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [query, setQuery] = useState({
    citizen_id: undefined,
    status: undefined,
    keywords: undefined,
    page: 1,
    page_size: isMobile ? 6 : PAGE_SIZE_LIST
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [openCreateModal, setOpenCreateModal] = useState(false);

  // Memoize handlers để tối ưu hiệu năng
  const handleSearchChange = useCallback(value => {
    setQuery(prevQuery => ({
      ...prevQuery,
      keywords: value || undefined,
      page: 1
    }));
  }, []);

  const handleSearch = useCallback(
    value => {
      setQuery(prevQuery => {
        const newQuery = {
          ...prevQuery,
          keywords: value || undefined,
          page: 1
        };
        if (searchRef) {
          searchRef(newQuery);
        }
        return newQuery;
      });
    },
    [searchRef]
  );

  const handleOpenCreateModal = useCallback(() => {
    setOpenCreateModal(true);
  }, []);

  const handleQuery = useCallback(
    (e, name) => {
      if (name === 'province_type') {
        setQuery(prevQuery => {
          const newQuery = {
            ...prevQuery,
            citizen_id: e.target.value
          };
          if (searchRef) {
            searchRef(newQuery);
          }
          return newQuery;
        });
      }
      if (name === 'status_type') {
        setQuery(prevQuery => {
          const newQuery = {
            ...prevQuery,
            status: e.target.value
          };
          if (searchRef) {
            searchRef(newQuery);
          }
          return newQuery;
        });
      }
    },
    [searchRef]
  );

  const handleClickFilter = useCallback(event => {
    setAnchorEl(event.currentTarget);
  }, []);

  const closeModal = useCallback(() => {
    setOpenCreateModal(false);
  }, []);

  return (
    <div className={classes.root}>
      {openCreateModal && (
        <CreateUser open={openCreateModal} onClose={closeModal} />
      )}
      <Box className={classes.groupSearch}>
        <div className={classes.groupSearchLeft}>
          <Typography className={classes.title}>Quản trị khách hàng</Typography>
        </div>
        <Box
          style={{
            marginLeft: '10px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '15px'
          }}
        >
          <SearchInput
            value={query.keywords || ''}
            onChange={handleSearchChange}
            onSearch={handleSearch}
            className={'searchInputDevice'}
            placeholder="Tên, số điện thoại hoặc email"
          />

          {isMobile ? (
            <Typography
              color="secondary"
              size="small"
              variant="contained"
              className="pt-2 mx-3 cursor-pointer"
            >
              <span
                className="cursor-pointer"
                aria-describedby="filter-module"
                onClick={handleClickFilter}
                style={{ fontSize: '15px', fontWeight: 'bold' }}
              >
                <img
                  src={`/static/iconSvg/filter.svg`}
                  style={{ paddingRight: '5px', paddingBottom: '4px' }}
                />
                &nbsp; Lọc
              </span>
              <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                <CommonFilterBox
                  isMobile
                  listProvinces={listProvinces}
                  statusOptions={[
                    { name: 'Hoạt động', value: 1 },
                    { name: 'Không hoạt động', value: 0 }
                  ]}
                  initialQuery={query}
                  onApply={q => {
                    setQuery(q);
                    searchRef(q);
                    setAnchorEl(null);
                  }}
                  onReset={q => {
                    setQuery(q);
                    searchRef(q);
                    setAnchorEl(null);
                  }}
                />
              </Popover>
            </Typography>
          ) : (
            <>
              <Box style={{ width: '172px' }}>
                <CssTextField
                  className="input-no-fieldset"
                  size="small"
                  fullWidth
                  select
                  margin="normal"
                  name="citizen_id"
                  onChange={e => handleQuery(e, 'province_type')}
                  SelectProps={{ native: true }}
                  InputProps={{
                    style: {
                      fontSize: '14px',
                      backgroundColor: '#ffffff',
                      padding: '1px 0px'
                    }
                  }}
                  variant="outlined"
                >
                  <option value={''}>Tất cả tỉnh thành</option>
                  {listProvinces?.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </CssTextField>
              </Box>

              <Box style={{ width: '172px' }}>
                <CssTextField
                  className="input-no-fieldset"
                  size="small"
                  fullWidth
                  select
                  margin="normal"
                  name="status"
                  onChange={e => handleQuery(e, 'status_type')}
                  SelectProps={{ native: true }}
                  InputProps={{
                    style: {
                      fontSize: '14px',
                      backgroundColor: '#ffffff',
                      padding: '1px 0px'
                    }
                  }}
                  variant="outlined"
                >
                  <option value={''}>Tất cả trạng thái</option>
                  <option value={1}>Hoạt động</option>
                  <option value={0}>Không hoạt động</option>
                </CssTextField>
              </Box>
            </>
          )}

          <Button
            style={{
              ...(isMobile && { lineHeight: '18px' }),
              color: '#ffff'
            }}
            className={classes.styleInputSearch}
            color="secondary"
            variant="contained"
            onClick={handleOpenCreateModal}
          >
            Thêm khách hàng
          </Button>
        </Box>
      </Box>
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

const useStyles = makeStyles(theme => ({
  root: {},
  importButton: {
    marginRight: theme.spacing(1)
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 172
  },

  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  title: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#0C1132',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
      fontWeight: '500'
    }
  },
  groupSearch: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    // overflowX: 'scroll',
    minWidth: '50%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '100%',
      gap: '8px'
    }
  },
  groupSearchLeft: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  searchInput: {
    width: '250px'
  },
  styleInputSearch: {
    height: '39px',
    textTransform: 'none',
    padding: '0px 1em'
  },
  exportBtn: {
    justifyContent: 'flex-end',
    display: 'flex',
    paddingTop: '10px',
    paddingBottom: '10px'
  },
  shadowBox: {
    boxShadow: '0 2px 5px rgba(0,0,0,.18)'
  }
}));

export default Toolbar;
